export default __webpack_public_path__ + "feather-webfont.91c1e78fbb5fbc7399d3.woff";